/**
 * La scheda dell'elemento di rete, dal lato della pagina.
 *
 * Sola lettura: qui si guarda un palo con tutto cio' che lo riguarda —
 * fotogrammi, candidati, constatazioni, voli passati. Le decisioni restano al
 * banco e alla copertura, che sono i posti dove hanno un lease e un outbox.
 */
import { get } from './api'
import type { Box, CoverageStatus } from './types'

export interface ElementFrame {
  photo_id: string
  filename: string
  width: number | null
  height: number | null
  tile: number | null
  levels: number | null
  tiles_url: string | null
  thumbnail_url: string | null
  camera: string | null
  quality: number | null
  taken_at: string | null
  method: string
  distance_m: number | null
  primary: boolean
  reviewed: boolean
  candidates: number
  findings: number
}

export interface ElementCandidate {
  detection_id: string
  code: string
  description: string
  source: string
  level: number | null
  confidence: number | null
  measured_distance_m: number | null
  minimum_distance_m: number | null
  photo_id: string | null
  photo_filename: string | null
  box: Box | null
  model_version: string | null
  decision: string | null
  final_level: number | null
  reason_code: string | null
  reviewer: string | null
  decided_at: string | null
}

export interface ElementFinding {
  finding_id: string
  code: string
  description: string
  level: number
  detection_id: string | null
  note: string | null
  created_at: string
}

export interface PastFlight {
  inspection_id: string
  external_inspection_id: number
  element_id: string
  state: string
  created_at: string
  findings: number
  frames: number
}

export interface ElementSheet {
  inspection_id: string
  element_id: string
  external_element_id: number
  element_type: string
  code: string | null
  description: string | null
  line_code: string | null
  line_description: string | null
  latitude: number | null
  longitude: number | null
  end_nodes: number[]
  status: CoverageStatus
  not_inspected_reason: string | null
  not_inspected_note: string | null
  frames: ElementFrame[]
  candidates: ElementCandidate[]
  findings: ElementFinding[]
  history: PastFlight[]
}

export function readElement(inspectionId: string, elementId: string): Promise<ElementSheet> {
  return get<ElementSheet>(`/inspections/${inspectionId}/elements/${elementId}`)
}
